import Promise from 'promise-polyfill';
import Variation from './variation.js';
import Reservation from './reservation.js';
import Line from './line.js';

class CheckLine{
    static scheduleValues = {
        reception: "acollida",
        morning: "mati",
        meal: "menjador",
        lunch: "dinar",
        afternoon: "tarda",
        permanence: "permanencia",
        morning_reception: "acollida-mati",
        afternoon_reception: "acollida-tarda",
        all: "tot"
    };

    static scheduleOrder = [
        "reception",
        "morning",
        "meal",
        "lunch",
        "afternoon",
        "permanence",
        "morning_reception",
        "afternoon_reception",
        "all"
    ];

    periodStart = null; //Periodo (Cuando empieza)
    periodEnd = null; //Periodo (Cuando termina)
    product = null; //Producto
    period = null; //Periodo
    schedules = []; //Horarios

    avaliablePeriods = null; //Periodos Disponibles en funcion del periodStart y del periodEnd
    productPeriods = null;

    constructor(periodStart, periodEnd, allPeriods){
        this.periodStart = Date.parse(periodStart);
        this.periodEnd = Date.parse(periodEnd);

        let _periodStart = this.periodStart;
        let _periodEnd = this.periodEnd;

        this.avaliablePeriods = allPeriods.filter(period => {
            let start = Date.parse(period.start);
            let end = Date.parse(period.end);

            return start.getTime() == _periodStart.getTime() && end.getTime() == _periodEnd.getTime();
        });

        this.productPeriods = allPeriods;
    }

    setProductById(productId){
        if (this.avaliablePeriods.map(p => p.product.id).indexOf(productId) >= 0){
            let product = this.avaliablePeriods.map(p => p.product).find(product => product.id == productId);
            this.product = product;
            this.period = this.avaliablePeriods.find(p => p.product.id == product.id);
            this.productPeriods = this.productPeriods.filter(p => p.product.id == product.id);

            this.schedules = [];

            if(this.product.variations.find(variation => variation.attributes.attribute_pa_horari == this.constructor.scheduleValues.morning)){
                this.schedules.push(this.constructor.scheduleValues.morning);
            }
            else if(this.product.variations.find(variation => variation.attributes.attribute_pa_horari == this.constructor.scheduleValues.all)){
                this.schedules.push(this.constructor.scheduleValues.all);
            }
        }
    }

    getProducts(){
        return this.avaliablePeriods.filter(p => p.stock > 0).map(p => p.product).unique();
    }

    addSchedule(schedule){
        if (this.schedules.indexOf(schedule) === -1 && Object.values(CheckLine.scheduleValues).indexOf(schedule) >= 0){
            this.schedules.push(schedule);
        }
    }

    schedulesToString(){
        return this.schedules.join(", ");
    }

    getAvaliableSchedules(){
        let schedules = {};

        if(!this.product){
            return schedules;
        }

        let values = Object.values(this.constructor.scheduleValues);
        let keys = Object.keys(this.constructor.scheduleValues);

        let product = this.product;
        for(let v = 0; v <= product.variations.length - 1; v++){
            let variation = product.variations[v];
            for(let attribute in variation.attributes){
                let _attribute = variation.attributes[attribute];
                let key = values.indexOf(_attribute);
                if(key >= 0){
                    schedules[keys[key]] = _attribute;
                }
            }
        }

        //Ordenamos los horarios en función del orden especificado más arriba (quizá en un futuro llegue parametrizado)
        let items = Object.entries(schedules);
        items = items.sort((a, b) => {
            return this.constructor.scheduleOrder.indexOf(a[0]) - this.constructor.scheduleOrder.indexOf(b[0]);
        });

        // Convertir la matriz ordenada de nuevo en un objeto
        let horarios = Object.fromEntries(items);

        return horarios;
    }

    getPeriodDescription(){
        if(this.period){
            return this.period.title;
        }
        else{
            return this.avaliablePeriods[0].title;
        }
    }
    
    getLines(){
        let lines = [];

        for(let schedule of this.schedules){
            lines.push(new Line(this.period, schedule, this.productPeriods));
        }

        return lines;
    }

    static extractVariationsAndReservations(checkLines){
        let lines = [];
        let variations = [];
        let reservations = [];

        for(let checkLine of checkLines){
            lines = lines.concat(checkLine.getLines());
        }

        let productIds = checkLines.map(ckl => ckl.period.product.id).unique();

        for (let productId of productIds) {
            for (let prop in this.scheduleValues) {
                let schedule = this.scheduleValues[prop];
                let group = lines.filter(line => {
                    return line && line.schedule == schedule && line.period && line.period.product.id == productId;
                });

                if (group.length) {
                    let result = this.getVariationsOrReservationsFromGroup(group);
                    
                    variations = variations.concat(result['variations']);
                    reservations = reservations.concat(result['reservations']);
                }
            }
        }

        return {
            variations,
            reservations
        };
    }

    static getVariationsOrReservationsFromGroup(group){
        let variations = [];
        let reservations = [];

        if(!group.length){
            return {
                variations,
                reservations
            };
        }

        let linesWithStock = [],  
            linesWithoutStock = [],
            strategy = group[0].period.product.strategy
        ;

        for(let line of group){
            if(line.period.stock > 0 || line.period.stock == -1){
                linesWithStock.push(line);
            }
            else{
                linesWithoutStock.push(line);
            }
        }

        switch(strategy){
            case "grouped":
                if(linesWithStock.length){
                    let duration = linesWithStock.length > 1 ? linesWithStock.map(p => p.duration).reduce((d1, d2) => d1 + d2) : linesWithStock[0].period.duration;
                    let variation = new Variation(linesWithStock.map(line => line.period), group[0].period.product, group[0].schedule, duration, group[0].period.product.variations);
                    variations.push(variation);
                }
        
                if(linesWithoutStock.length){
                    let duration = linesWithoutStock.length > 1 ? linesWithoutStock.map(p => p.period.duration).reduce((d1, d2) => d1 + d2) : linesWithoutStock[0].period.duration;
                    let reservation = new Reservation(linesWithoutStock.map(line => line.period), group[0].period.product, group[0].schedule, duration, group[0].period.product.variations);
                    reservations.push(reservation);
                }

                break;
            case "individual": 
                let linesToCheck = [linesWithStock, linesWithoutStock];

                for(let index = 0; index <= linesToCheck.length - 1; index++){
                    let lines = linesToCheck[index];
                    
                    if(lines.length){
                        for(let i = 0; i <= lines.length - 1; i++){
                            //let isAllPeriodsSelected = true;
                            let line = lines[i];
                            
                            /*
                            for(let p = 0; p <= line.avaliablePeriods.length - 1; p++){
                                let period = line.avaliablePeriods[p];
                                let coincident = lines.find(_line => _line.schedule == line.schedule && _line.period.id == period.id);
                                
                                if(!coincident){
                                    isAllPeriodsSelected = false;
                                    break;
                                }
                            }
                            */
                            
                            let duration = parseInt(line.duration);
                            let periods = [line.period];

                            /*
                            if(isAllPeriodsSelected){
                                for(let a = 0; a <= lines.length - 1; a++){
                                    let lineToCheck = lines[a];
                                    if(line.schedule == lineToCheck.schedule && line.period.product.id == lineToCheck.period.product.id && line.period.id != lineToCheck.period.id){
                                        periods.push(lineToCheck.period);
                                        duration += parseInt(lineToCheck.duration);

                                        lines.splice(a, 1);
                                        if(a < i) i--;
                                    }
                                }
                            }
                            */
                            
                            if(index == 0){
                                let variation = new Variation(periods, line.period.product, line.schedule, duration, line.period.product.variations);   
                                variations.push(variation);
                            }
                            else{
                                let reservation = new Reservation(periods, line.period.product, line.schedule, duration, line.period.product.variations);
                                reservations.push(reservation);
                            }
                        }
                    }
                }
            
                break;
        }       
        
        return {
            variations,
            reservations
        };
    }
}

export default CheckLine;